export const AA_BASE_PATH = '/';
export const ACCOUNT_BASE_PATH = '/account/';
export const ACCOUNT_SWITCH_BASE_URL = '/account/switch';
export const AA_XHR_BASE_PATH = '/account/xhr/';
export const ACCOUNT_XHR_BASE_PATH = AA_XHR_BASE_PATH;
